import { render, staticRenderFns } from "./StaffLeaveAssignment.vue?vue&type=template&id=59da0dd6&scoped=true&"
import script from "./StaffLeaveAssignment.vue?vue&type=script&lang=js&"
export * from "./StaffLeaveAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59da0dd6",
  null
  
)

export default component.exports